<template>
  <div class="page_larp_teams">
    <h1>Týmy na larp</h1>
    <div class="new">
      <dropdown :items="larpCategories" @change="change">
        <template v-slot:label>{{ newTeamCategory | cz }}</template>
        <template v-slot:item="props">{{ props.id | cz }}</template>
      </dropdown>
      <button
        class="create"
        :class="{ disabled: isTeamChangeNotAllowed }"
        @click="addTeam"
        title="Vytvořit nový tým"
      >
        <i class="fas fa-plus"></i>
      </button>
    </div>
    <div class="registration-end">Možnost změny týmu končí: <strong>{{ config.teamAndRoyRegistrationEndAt | cz }}</strong></div>
    <tabloid name="teams" :columns="columns" :data="myTeams">
      <template v-slot:name="{ row }">{{ row | larp_team_name_full }}</template>
      <template v-slot:capacity="{ value, row }">2 &lt; <span :class="row.capacityClass">{{ value }}</span> &lt; 2</template>
      <template v-slot:members="{ value, row }">
        <div v-for="(member, participantId) in value" :key="participantId" class="member">
          <i
            class="fa fa-times"
            :class="{ disabled: isTeamChangeNotAllowed }"
            @click="removePlayer(participantId)"
            title="Odebrat z týmu"
          />
          <span>
            {{ member | participant_name }}
          </span>
        </div>
        <div class="add_group">
          <dropdown
            @change="participant => addPlayer(participant, row.id)"
            :items="row.availablePlayers"
            :disabled="isTeamChangeNotAllowed"
            class="add"
          >
            <template v-slot:label>
              <i class="fas fa-plus"></i>
            </template>
            <template v-slot:item="props">{{ props.item | participant_name }}</template>
          </dropdown>
        </div>
      </template>
      <template v-slot:contactPhone="{ row }">
        <inputer name="Kontaktní telefon" :paths="['larpTeams', row.id, 'contactPhone']" />
      </template>
      <template v-slot:actions="{ row }">
        <div class="remove" :class="{ disabled: isTeamChangeNotAllowed }" @click="removeTeam(row.id)">
          <i class="fa fa-times" />
        </div>
      </template>
    </tabloid>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { _ } from "../extend";
import tabloid from "../components/tabloid";
import inputer from "../components/inputer";
import dropdown from "../components/dropdown";

export default {
  name: "larp_teams",
  components: {
    tabloid,
    inputer,
    dropdown,
  },
  data: () => ({
    newTeamCategory: "royalRanger",
    selectShowed: false,
    columns: {
      name: { title: "Jméno" },
      capacity: { title: "Kapacita" },
      members: { title: "Členové" },
      contactPhone: { title: "Kontaktní telefon", headerAttributes: { title: "nepovinné" } },
      actions: { title: " " },
    },
  }),
  computed: {
    ...mapState(["categories", "config"]),
    larpCategories() {
      return _.filter(this.categories, category => category.excludeFromLarp == false);
    },
    myTeams() {
      let result = _.filter(this.$store.state.larpTeams, team => team.outpostId == this.$store.state.outpost.id);
      result = _.select(result, t => {
        const team = { ...t };
        team.category = team.id.split("-")[1];
        team.members = _.filter(this.$store.state.participants, p => p.larpTeamId == team.id);
        team.capacity = _.count(team.members);
        team.capacityClass = team.capacity > 2 || team.capacity < 2 ? "wrong" : "right";
        team.availablePlayers = _.filter(
          this.$store.state.participants,
          participant =>
            participant.playingOutpostId == this.$store.state.outpost.id &&
            participant.larpTeamId == null &&
            this.$store.state.childCategories[team.category].includes(participant.categoryId));
        return team;
      });

      return result;
    },
    isTeamChangeNotAllowed() {
      return this.config.teamAndRoyRegistrationEndAt < new Date();
    },
  },
  methods: {
    addTeam() {
      if (this.isTeamChangeNotAllowed) return;

      this.$store.dispatch("createLarpTeam", {
        categoryId: this.newTeamCategory
      });
    },
    removeTeam(id) {
      if (this.isTeamChangeNotAllowed) return;

      if (confirm("Opravdu chcete smazat celý tým?")) {
        this.$store.commit("removeLarpTeam", { teamId: id });
      }
    },
    addPlayer(participant, larpTeamId) {
      if (this.isTeamChangeNotAllowed) return;

      this.$store.commit("update", {
        paths: ["participants", participant.id, "larpTeamId"],
        value: larpTeamId
      });
    },
    removePlayer(participantId) {
      if (this.isTeamChangeNotAllowed) return;

      this.$store.commit("update", {
        paths: ["participants", participantId, "larpTeamId"],
        value: null
      });
    },
    change(value, key) {
      this.newTeamCategory = key;
      this.selectShowed = false;
    },
  },
  mounted() {
    // team members count
    this.$store.commit("addEventHandler", {
      paths: ["participants", "*", "larpTeamId"],
      id: '0f33a353-ba86-4492-a81a-b9b51633baac',
      action: function () {
        _.select(this.myTeams, team => {
          var count = team.capacity;
          var paths = ["larpTeams", team.id];
          var isValid = this.$store.getters.isValidAt(paths);

          // valid
          if (count == 2) {
            if (!isValid) {
              this.$store.commit("removeValidationError", {
                paths: paths
              });
            }
          }
          // invalid
          else if (isValid) {
            this.$store.commit("addValidationError", {
              paths: paths,
              message: `Špatný počet účastníků u týmu ${this.$options.filters.larp_team_name_full(team)}`
            });
          }
        });
      }.bind(this)
    });
    this.$store.commit("addEventHandler", {
      paths: ["larpTeams", "*"],
      id: '0a0ef876-ee6f-4afa-a72b-211f3deeeafb',
      action: function (type, paths) {
        if (type == "add") {
          this.$store.commit("addValidationError", {
            paths: paths,
            message: `Špatný počet účastníků: ${paths[1]}`
          });
        } else if (type == "remove") {
          this.$store.commit("removeValidationError", {
            paths: paths
          });
        }
      }.bind(this)
    });
  }
};
</script>

<style lang="sass">
@import ../sass/_components

.page_larp_teams
  @include table-view()
  grid-template-areas: "label action end link" "table table table table"
  grid-template-columns: auto auto auto 1fr
  grid-column-gap: 1rem
  h1
    grid-area: label
  .new
    grid-area: action
    display: flex
    .input-select .label
      @include first-input()
    .create
      @include button-primary()
      @include last-input()
      &.disabled
        cursor: not-allowed
  .registration-end
    grid-area: end
    align-self: center
    strong
      font-weight: bold
  table
    grid-area: table

  tr
    .wrong, .right
      font-weight: bold
    .wrong
      color: $c-danger
    .right
      color: $c-primary

    .member
      padding: .5rem
      i.fa-times
        margin: 0 5px
        cursor: pointer
        &.disabled
          cursor: not-allowed
    .add_group
      display: flex
      .add .label
        @include button-primary()
      .label.disabled
          cursor: not-allowed
    .remove
      @include button-danger()
      &.disabled
        cursor: not-allowed
</style>